<span
  tnTooltipPosition="above"
  [tnTestId]="'role-missing'"
  [disableFocusableElements]="!!template()"
  [class]="['role-missing', class()]"
  [tnTooltip]="'Missing permissions for this action' | translate"
>
  <ng-container *ngTemplateOutlet="template()"></ng-container>
  <tn-icon name="lock" library="mdi" class="role-missing-icon"></tn-icon>
</span>
